export const GET_USERS = "GET_USERS";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAIL = "GET_USERS_FAIL";

const initialState = {
  data: [],
  loading: false,
  hasError: false,
  messageError: "",
};

export default function users(state = initialState, action) {
  switch (action.type) {
    case GET_USERS: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_USERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data,
      };
    }

    case GET_USERS_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }
    default:
      return state;
  }
}

export function getUsers(qryString = "") {
  const url = qryString ? "Auth/Users?usrQry=" + qryString : "Auth/Users";

  return {
    type: GET_USERS,
    payload: {
      request: {
        url,
      },
    },
  };
}
